<nav class="side-menu v-row" id="side-menu"
  [attr.aria-label]="translate.currentLang === 'en' ? 'Main menu' : 'প্রধান মেনু'"
  [class.mobile-open]="isMobileMenuOpen || document.body.classList.contains('mobile-menu-open')">
  <div class="align-items-center row no-gutters">
    <div class="logo-floater float-left row no-gutters align-items-center">
      <a class="navbar-brand" routerLink="/dashboard" [queryParams]="{ uid: currentUser?.id }"
        (click)="closeMobileMenuIfNeeded()" [attr.aria-label]="translate.currentLang === 'en' ? 'CAL home' : 'CAL হোম'">
        <img class="collapse-out" src="../../assets/images/logo/cal-logo-white-2x.png" width="150px" height="88px" alt="" />
        <img class="collapse-in" src="/assets/images/logo/cal-logo-sm.png" alt="" />
      </a>
    </div>
    <!-- Collapses the menu on desktop; closes the drawer on mobile -->
    <button type="button" class="collapse-toggle-btn" (click)="onToggleCollapse()" [attr.aria-label]="toggleLabel">
      <i class="fas" [ngClass]="isMobile ? 'fa-times' : (isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left')"></i>
    </button>
    <div class="logo-divider"></div>
  </div>
  <ul class="p-0" [hidden]="userInProgress">
    <li *ngFor="let item of menuItems" [routerLinkActive]="['active-route']" #rla="routerLinkActive"
      [routerLinkActiveOptions]="{ exact: !!item.exact }">
      <a [routerLink]="item.link" [queryParams]="item.withUid ? { uid: currentUser?.id } : null"
        [attr.aria-current]="rla.isActive ? 'page' : null" [attr.title]="isCollapsed ? label(item) : null"
        [attr.aria-label]="isCollapsed ? label(item) : null" (click)="closeMobileMenuIfNeeded()">
        <img [src]="item.icon" alt="" />
        <span>{{ label(item) }}</span>
      </a>
    </li>
  </ul>
  <ul class="sub-menu p-0">
    <li [routerLinkActive]="['active-route']" #adminRla="routerLinkActive" *ngIf="isSuperAdmin || viewEditprdSignups">
      <a routerLink="/super-admin/manage-prd-signup" (click)="closeMobileMenuIfNeeded()"
        [attr.aria-current]="adminRla.isActive ? 'page' : null"
        [attr.title]="isCollapsed ? (translate.currentLang === 'en' ? 'Super Admin' : 'সুপার অ্যাডমিন') : null"
        [attr.aria-label]="isCollapsed ? (translate.currentLang === 'en' ? 'Super Admin' : 'সুপার অ্যাডমিন') : null">
        <img src="assets/images/icons/admin.svg" alt="" />
        <span>{{ translate.currentLang === 'en' ? 'Super Admin' : 'সুপার অ্যাডমিন' }}</span>
      </a>
    </li>
  </ul>
  <ul class="menu-bottom pb-0">
    <li>
      <button type="button" class="logout-btn" (click)="logout(); closeMobileMenuIfNeeded()"
        [attr.title]="isCollapsed ? (translate.currentLang === 'en' ? 'Logout' : 'লগআউট') : null"
        [attr.aria-label]="isCollapsed ? (translate.currentLang === 'en' ? 'Logout' : 'লগআউট') : null">
        <img alt="" src="assets/icons/Sign_out_squre_light.svg" />
        <span>{{ translate.currentLang === 'en' ? 'Logout' : 'লগআউট' }}</span>
      </button>
    </li>
  </ul>
</nav>
